import Vue from "vue";
import Router from "vue-router";
import Layout from "./views/layout/index.vue";
import Login from "./views/login/index.vue";
import { Notify } from 'vant';

Vue.use(Router);

const routes = [
  {
    path: "/",
    name: "index",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "home",
    component: () => import("@/views/home/index"),
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    // meta: { auth: true }
  },
  {
    path: "/register",
    name: "register",
    meta: { title: "注册", name: "" },
    component: () => import("@/views/login/register"),
  },
  {
    path: "/forget",
    name: "forget",
    meta: { title: "忘记密码", name: "" },
    component: () => import("@/views/login/forget"),
  },
  {
    path: "/mine",
    name: "mine",
    meta: { title: "我的", name: "" },
    component: () => import("@/views/mine/index"),
  },
  {
    path: "/creditStatus",
    name: "creditStatus",
    meta: { title: "授信申请", name: "" },
    component: () => import("@/views/credit/creditStatus"),
  },
  {
    path: "/tax",
    name: "tax",
    meta: { title: "税务体检", name: "" },
    component: () => import("@/views/tax/index"),
  },
  {
    path: "/callbackPage",
    name: "callbackPage",
    meta: { title: "回调页面", name: "" },
    component: () => import("@/views/callback/callbackPage"),
  },
  {
    path: "/business",
    name: "business",
    meta: { title: "业务概况", name: "" },
    component: () => import("@/views/business/index"),
  },
  {
    path: "/fundManage",
    name: "fundManage",
    meta: { title: "资金管理", name: "" },
    component: () => import("@/views/fundManage/fundView"),
  },
  {
    path: "/pool",
    name: "pool",
    meta: { title: "项目资金池", name: "" },
    component: () => import("@/views/pool/index"),
  },
  {
    path: "/collectionDetails",
    name: "collectionDetails",
    meta: { title: "预收款详情", name: "" },
    component: () => import("@/views/pool/collectionDetails"),
  },
  {
    path: "/issueDetails",
    name: "issueDetails",
    meta: { title: "融资发放详情", name: "" },
    component: () => import("@/views/pool/issueDetails"),
  },
  {
    path: "/balanceDetails",
    name: "balanceDetails",
    meta: { title: "融资余额详情", name: "" },
    component: () => import("@/views/pool/balanceDetails"),
  },
  {
    path: "/pooldetails",
    name: "pooldetails",
    meta: { title: "项目资金池详情", name: "" },
    component: () => import("@/views/pool/pooldetails"),
  },
  {
    path: "/settledDetails",
    name: "settledDetails",
    meta: { title: "已结算订单详情", name: "" },
    component: () => import("@/views/pool/settledDetails"),
  },
  {
    path: "/bondDetails",
    name: "bondDetails",
    meta: { title: "已结算订单详情", name: "" },
    component: () => import("@/views/pool/bondDetails"),
  },
  {
    path: "/order",
    name: "order",
    meta: { title: "我的订单", name: "" },
    component: () => import("@/views/order/myOrder"),
  },
  {
    path: "/orderDetails",
    name: "orderDetails",
    meta: { title: "订单详情", name: "" },
    component: () => import("@/views/order/details"),
  },
  {
    path: "/payment",
    name: "payment",
    meta: { title: "付款申请", name: "" },
    component: () => import("@/views/payment/index"),
  },
  {
    path: "/payDetails",
    name: "payDetails",
    meta: { title: "付款详情", name: "" },
    component: () => import("@/views/payment/details"),
  },
  {
    path: "/goodsPayDetails",
    name: "goodsPayDetails",
    meta: { title: "货款详情", name: "" },
    component: () => import("@/views/payment/goodsPayDetails"),
  },
  {
    path: "/payApply",
    name: "payApply",
    meta: { title: "付款申请详情", name: "" },
    component: () => import("@/views/payment/payApply"),
  },
  {
    path: "/payee",
    name: "payee",
    meta: { title: "收款人", name: "" },
    component: () => import("@/views/payment/payee"),
  },
  {
    path: "/contract",
    name: "contract",
    meta: { title: "新增相同收款人其他待付款合同", name: "" },
    component: () => import("@/views/payment/contract"),
  },
  {
    path: "/message",
    name: "message",
    meta: { title: "我的消息", name: "" },
    component: () => import("@/views/message/index"),
  },
  {
    path: "/messageDetails",
    name: "messageDetails",
    meta: { title: "消息详情", name: "" },
    component: () => import("@/views/message/messageDetails"),
  },
  {
    path: "/material",
    name: "material",
    meta: { title: "我的资料", name: "" },
    component: () => import("@/views/material/index"),
  },
  {
    path: "/addmaterial",
    name: "addmaterial",
    meta: { title: "资料添加", name: "" },
    component: () => import("@/views/material/addmaterial"),
  },
  {
    path: "/addMaterialBuyer",
    name: "addMaterialBuyer",
    meta: { title: "添加国外客户", name: "" },
    component: () => import("@/views/material/addMaterialBuyer"),
  },
  {
    path: "/country",
    name: "country",
    meta: { title: "国家选择", name: "" },
    component: () => import("@/views/material/country"),
  },
  {
    path: "/addMaterialGoods",
    name: "addMaterialGoods",
    meta: { title: "添加产品", name: "" },
    component: () => import("@/views/material/addMaterialGoods"),
  },
  {
    path: "/hscode",
    name: "hscode",
    meta: { title: "HSCODE选择", name: "" },
    component: () => import("@/views/material/hscode"),
  },
  {
    path: "/addMaterialSupplier",
    name: "addMaterialSupplier",
    meta: { title: "添加供应商", name: "" },
    component: () => import("@/views/material/addMaterialSupplier"),
  },
  {
    path: "/entrust",
    name: "entrust",
    meta: { title: "委托函", name: "" },
    component: () => import("@/views/entrust/index"),
  },
  {
    path: "/entrustDetails",
    name: "entrustDetails",
    meta: { title: "委托函详情", name: "" },
    component: () => import("@/views/entrust/details"),
  },
  {
    path: "/upload",
    name: "upload",
    meta: { title: "上传委托函", name: "" },
    component: () => import("@/views/entrust/upload"),
  },
  {
    path: "/sign",
    name: "sign",
    meta: { title: "电子签名", name: "" },
    component: () => import("@/views/entrust/sign"),
  },
  {
    path: "/preview",
    name: "preview",
    meta: { title: "查看文件", name: "" },
    component: () => import("@/views/entrust/preview"),
  },
  {
    path: "/confirmPay",
    name: "confirmPay",
    meta: { title: "付款确认列表", name: "" },
    component: () => import("@/views/confirmPay/index"),
  },
  {
    path: "/confirmPayFilePreview",
    name: "confirmPayFilePreview",
    meta: { title: "付款确认列表", name: "" },
    component: () => import("@/views/confirmPay/preview"),
  },
  // {
  //   path: "/filePreview",
  //   name: "filePreview",
  //   meta: { title: "文件预览", name: "" },
  //   component: () => import("@/views/confirmPay/filePreview"),
  // },
];

routes.forEach((route) => {
  route.path = route.path || "/" + (route.name || "");
});

const router = new Router({ routes, mode: "history" });

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  // if (to.matched.some(m => m.meta.auth)) {
  //   if (window.localStorage.isLogin === 1) {
  //     next()
  //   } else if (to.path !== '/') {
  //     Notify({ type: 'primary', message: '请登录后操作' });
  //     next({ path: '/login' })
  //   }
  // } else {
  next();
  // }
});
export { router };
